import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '@mui/material';
import * as React from 'react';
import { FlexBox } from '../../box';
import { TextField } from '../../textfield';
import { measureText } from '../../typography';
import { FacilityValue, facilityValueTypography } from './facility-value';
export const FacilityInput = (props) => {
    const { topNav, reduced, emptySelectionLabel, ...textfieldProps } = props;
    const [iconWidth, setIconWidth] = React.useState(0);
    const { spacing } = useTheme();
    const inputValue = props.inputProps.value;
    const displayValue = (Array.isArray(inputValue) && !inputValue.length) || !inputValue
        ? (emptySelectionLabel ?? '')
        : inputValue;
    // icon-width + padding + text-width
    const width = reduced
        ? iconWidth
        : `calc(${iconWidth}px + ${spacing(1)} + ${Math.min(facilityValueTypography.maxWidth, measureText(displayValue, facilityValueTypography.variant))}px)`;
    const onIconRef = (icon) => {
        setIconWidth(icon?.getBoundingClientRect().width || 0);
    };
    return (_jsxs(FlexBox, { position: "relative", overflow: "hidden", children: [_jsx(TextField, { ...textfieldProps, slotProps: {
                    input: textfieldProps.InputProps,
                    inputLabel: textfieldProps.InputLabelProps,
                    htmlInput: {
                        ...textfieldProps.inputProps,
                        style: { width, cursor: 'pointer' },
                        value: ''
                    }
                }, readOnly: true }), _jsx(FacilityValue, { topNav: topNav, reduced: reduced, sx: { position: 'absolute', left: 8 }, onIconRef: onIconRef, children: displayValue })] }));
};
